<template>
<section class="dealer_select">
    <div class="wrap">
        <div class="dealer">
            <img :src="brandItem.url" class="brandImg">
            <p>{{ (brandItem) ? brandItem.name : ''}}</p>
        </div>
    </div>

    <ul class="menu_ul dealer-list">
        <li v-for="dealer in dealerItems" :key="`dealer-list-item-${dealer.id}`">
            <router-link :to="`/dealerInfo/${dealer.id}`">
                {{dealer.name}}
            </router-link>
        </li>
    </ul>
</section>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name:'DealerList',
    async created() {
        this.setHeaderTitle();
        await this.getItems();
        this.$store.commit('SHOW_ONLOAD');
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapState({
            brandItems: state => state.brand.items,
            dealerItems: state => state.dealer.items,
        }),
        brandId(){
            return this.$route.params.brandId;
        },
        brandItem(){
            return this.brandItems.find((brand) => { return brand.id == this.brandId });
        }

    },
    methods: {
        setHeaderTitle() {
            this.$store.state.headerTitle = '딜러사 둘러보기';
        },
        getItems() {
            this.$store.dispatch('GET_DEALER_LIST', {
                brandId:this.brandId
            })
        }
    },
}
</script>

<style>
    #app {
        background:#fff
    }
</style>